<template>
    <div class="flex contact-table-actions">
        <button class="block w-full px-4 py-2 text-base leading-5 text-left text-gray-400 hover:text-blue-400 transition duration-150 ease-in-out"
                @click.stop="$inertia.visit(route('dashboard', { list_id: data.tra_id }))">
            <font-awesome-icon :icon="['fas', 'comment']"></font-awesome-icon><span class="sr-only">Message</span>
        </button>
        <button class="block w-full px-4 py-2 text-base leading-5 text-left text-gray-400 hover:text-blue-400 transition duration-150 ease-in-out"
                @click.stop="$inertia.visit(route('groups.edit.form', data.tra_id))">
            <font-awesome-icon :icon="['far', 'pen-to-square']"></font-awesome-icon><span class="sr-only">Edit</span>
        </button>
        <button class="block w-full px-4 py-2 text-base leading-5 text-left text-gray-400 hover:text-blue-400 transition duration-150 ease-in-out">
            <font-awesome-icon :icon="['far', 'eye']"></font-awesome-icon><span class="sr-only">View</span>
        </button>
    </div>
</template>

<script>


export default {
    name: "ListTableActionButtons",
    components: {
    },
    data() {
        return {
        }
    },
    methods: {
    },
    props: {
        data: {
            type: Object,
            default: () => {}
        },
    }
}
</script>

<style scoped>
    .contact-table-actions {
        max-width: 40px;
    }
</style>
